/* BASIQ · Pop-up de país e idioma
   1. Pregunta a Shopify qué país e idioma detecta (/browsing_context_suggestions.json).
   2. Si coincide con lo que ya se está viendo, no hace nada.
   3. Si no, lo enseña UNA sola vez. Al elegir, cerrar o cambiar de país en el header/footer,
      queda guardado y no vuelve a salir. */
(function () {
  'use strict';

  var KEY = 'basiq_geo_v1';
  var root = null;
  var data = null;
  var sel = { country: null, locale: null };
  var locked = false;
  var lastFocus = null;

  var TXT = {
    es: {
      title: 'Parece que estás en {c}',
      titleLang: '¿Prefieres ver la tienda en español?',
      sub: 'Elige tu país e idioma para ver los precios en tu moneda y el envío a tu zona.',
      country: 'País / moneda',
      language: 'Idioma',
      go: 'Continuar',
      stay: 'Seguir en {c} ({cur})',
      stayLang: 'Seguir en {l}',
      langNames: { en: 'inglés', es: 'español' },
      search: 'Buscar país o moneda',
      none: 'No encontramos ese país',
      close: 'Cerrar',
      back: 'Volver'
    },
    en: {
      title: 'Looks like you’re in {c}',
      titleLang: 'Would you like to shop in English?',
      sub: 'Choose your country and language to see prices in your currency and shipping to your area.',
      country: 'Country / currency',
      language: 'Language',
      go: 'Continue',
      stay: 'Stay on {c} ({cur})',
      stayLang: 'Stay in {l}',
      langNames: { en: 'English', es: 'Spanish' },
      search: 'Search country or currency',
      none: 'No country found',
      close: 'Close',
      back: 'Back'
    }
  };
  var THE = ['GB', 'US', 'NL', 'AE', 'PH', 'CZ', 'DO', 'BS', 'GM', 'MV', 'VA'];
  var SPANISH = ['ES', 'MX', 'AR', 'CL', 'CO', 'PE', 'VE', 'EC', 'GT', 'CU', 'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'CR', 'PA', 'UY', 'PR', 'GQ'];

  /* ---------- memoria (localStorage + cookie de respaldo) ---------- */

  function done() {
    try { if (window.localStorage.getItem(KEY)) return true; } catch (e) {}
    return document.cookie.indexOf(KEY + '=1') !== -1;
  }
  function remember() {
    try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
    try { document.cookie = KEY + '=1; path=/; max-age=31536000; SameSite=Lax'; } catch (e) {}
  }

  /* Cualquier cambio de país/idioma (header, footer, este pop-up) cuenta como "ya elegido" */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.querySelector && f.querySelector('input[name="form_type"][value="localization"]')) remember();
  }, true);

  /* ---------- utilidades ---------- */

  function $(s) { return root.querySelector(s); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }
  function flag(iso) { return 'https://flagcdn.com/' + String(iso).toLowerCase() + '.svg'; }
  function byIso(iso) {
    for (var i = 0; i < data.countries.length; i++) if (data.countries[i].iso === iso) return data.countries[i];
    return null;
  }
  function hasLang(iso) {
    for (var i = 0; i < data.languages.length; i++) if (data.languages[i].iso === iso) return true;
    return false;
  }
  function T() { return TXT[sel.locale] || TXT[sel.locale && sel.locale.slice(0, 2)] || TXT.en; }

  var namesCache = {};
  function cname(iso, lang) {
    var k = lang + iso;
    if (namesCache[k]) return namesCache[k];
    var n = null;
    try { n = new Intl.DisplayNames([lang], { type: 'region' }).of(iso); } catch (e) {}
    if (!n || n === iso) { var c = byIso(iso); n = c ? c.name : iso; }
    namesCache[k] = n;
    return n;
  }

  /* ---------- pintar ---------- */

  function paint() {
    var t = T();
    var lang = sel.locale || data.locale;
    var c = byIso(sel.country);
    var cur = byIso(data.country);

    root.querySelectorAll('[data-gp-t]').forEach(function (el) { el.textContent = t[el.getAttribute('data-gp-t')] || ''; });
    root.querySelectorAll('[data-gp-t-aria]').forEach(function (el) { el.setAttribute('aria-label', t[el.getAttribute('data-gp-t-aria')] || ''); });
    $('[data-gp-search]').setAttribute('placeholder', t.search);

    var showFlagOf = state.detected && byIso(state.detected) ? state.detected : sel.country;
    $('[data-gp-flag]').src = flag(showFlagOf);

    if (state.detected && byIso(state.detected)) {
      var n = cname(state.detected, lang);
      if (lang === 'en' && THE.indexOf(state.detected) !== -1) n = 'the ' + n;
      $('[data-gp-title]').textContent = t.title.replace('{c}', n);
    } else {
      $('[data-gp-title]').textContent = t.titleLang;
    }

    if (c) {
      $('[data-gp-sflag]').src = flag(c.iso);
      $('[data-gp-cname]').textContent = cname(c.iso, lang);
      $('[data-gp-ccur]').textContent = c.cur + ' ' + c.sym;
    }

    $('[data-gp-langwrap]').hidden = data.languages.length < 2;
    $('[data-gp-langs]').innerHTML = data.languages.map(function (l) {
      var on = l.iso === sel.locale;
      return '<button type="button" lang="' + esc(l.iso) + '" data-gp-lang="' + esc(l.iso) + '" aria-pressed="' + on + '">' + esc(l.name) + '</button>';
    }).join('');
    $('[data-gp-langs]').setAttribute('aria-label', t.language);

    $('[data-gp-go]').textContent = t.go;
    var stay = t.close;
    if (cur && sel.country === data.country && sel.locale !== data.locale) {
      stay = t.stayLang.replace('{l}', t.langNames[data.locale] || data.locale);
    } else if (cur) {
      stay = t.stay.replace('{c}', cname(cur.iso, lang)).replace('{cur}', cur.cur + ' ' + cur.sym);
    }
    $('[data-gp-stay]').textContent = stay;
  }

  function paintList() {
    var lang = sel.locale || data.locale;
    var list = data.countries.slice().sort(function (a, b) {
      return cname(a.iso, lang).localeCompare(cname(b.iso, lang), lang);
    });
    $('[data-gp-items]').innerHTML = list.map(function (c) {
      var n = cname(c.iso, lang);
      return '<li data-gp-name="' + esc(norm(n + ' ' + c.name + ' ' + c.iso + ' ' + c.cur)) + '">' +
        '<button type="button" data-gp-country="' + esc(c.iso) + '"' + (c.iso === sel.country ? ' aria-current="true"' : '') + '>' +
          '<img src="' + flag(c.iso) + '" alt="" width="22" height="22" loading="lazy">' +
          '<span>' + esc(n) + '</span><span class="gp__cur">' + esc(c.cur + ' ' + c.sym) + '</span>' +
        '</button></li>';
    }).join('');
  }

  function filter() {
    var q = norm($('[data-gp-search]').value);
    var shown = 0;
    root.querySelectorAll('[data-gp-items] li').forEach(function (li) {
      var hit = !q || li.getAttribute('data-gp-name').indexOf(q) !== -1;
      li.hidden = !hit;
      if (hit) shown++;
    });
    $('[data-gp-empty]').hidden = shown > 0;
  }

  function showList(on) {
    $('[data-gp-main]').hidden = on;
    $('[data-gp-list]').hidden = !on;
    if (on) {
      paintList();
      $('[data-gp-search]').value = '';
      filter();
      var cur = $('[data-gp-items] [aria-current="true"]');
      if (cur) cur.scrollIntoView({ block: 'center' });
      if (window.matchMedia('(min-width: 750px)').matches) $('[data-gp-search]').focus({ preventScroll: true });
    } else {
      $('[data-gp-open-list]').focus({ preventScroll: true });
    }
  }

  /* ---------- abrir / cerrar ---------- */

  var state = { detected: null };

  function lock(on) {
    if (on === locked) return;
    locked = on;
    if (window.BasiqScrollLock) {
      if (on) window.BasiqScrollLock.lock(); else window.BasiqScrollLock.unlock();
    } else {
      document.documentElement.style.overflow = on ? 'hidden' : '';
    }
  }

  function open() {
    lastFocus = document.activeElement;
    paint();
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');
    lock(true);
    if (!root.getAttribute('data-preview')) remember();
    var box = $('.gp__box');
    if (box) box.focus({ preventScroll: true });
  }

  function close() {
    remember();
    root.classList.remove('is-open');
    lock(false);
    window.setTimeout(function () { root.hidden = true; showList(false); }, 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function go() {
    remember();
    var c = sel.country, l = sel.locale;
    if (c === data.country && l === data.locale) { close(); return; }
    $('[data-gp-in-country]').value = c;
    $('[data-gp-in-locale]').value = l;
    $('[data-gp-go]').classList.add('is-loading');
    var form = document.getElementById('BasiqGeoForm');
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }

  /* ---------- eventos ---------- */

  function bind() {
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-gp-close]')) { close(); return; }
      if (t.closest('[data-gp-stay]')) { close(); return; }
      if (t.closest('[data-gp-go]')) { go(); return; }
      if (t.closest('[data-gp-open-list]')) { showList(true); return; }
      if (t.closest('[data-gp-back]')) { showList(false); return; }
      var lb = t.closest('[data-gp-lang]');
      if (lb) { sel.locale = lb.getAttribute('data-gp-lang'); paint(); return; }
      var cb = t.closest('[data-gp-country]');
      if (cb) { sel.country = cb.getAttribute('data-gp-country'); paint(); showList(false); }
    });
    $('[data-gp-search]').addEventListener('input', filter);
    $('[data-gp-search]').addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      var first = root.querySelector('[data-gp-items] li:not([hidden]) button');
      if (first) first.click();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || root.hidden) return;
      if (!$('[data-gp-list]').hidden) showList(false); else close();
    });
  }

  /* ---------- esperar al aviso de cookies de Shopify (no pisarlo) ---------- */

  function bannerUp() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var s = window.getComputedStyle(b);
    if (s.display === 'none' || s.visibility === 'hidden' || Number(s.opacity) === 0) return false;
    var r = b.getBoundingClientRect();
    return r.height > 0 && r.top < window.innerHeight;
  }

  function afterConsent(cb) {
    var fired = false;
    function go() {
      if (fired) return;
      fired = true;
      document.removeEventListener('visitorConsentCollected', onConsent);
      cb();
    }
    function onConsent() { window.setTimeout(go, 500); }
    document.addEventListener('visitorConsentCollected', onConsent);
    /* Sale cuando el aviso no está (o ya se ha cerrado) durante dos comprobaciones seguidas */
    (function check(clear) {
      if (fired) return;
      if (bannerUp()) clear = 0; else clear++;
      if (clear >= 2) { go(); return; }
      window.setTimeout(function () { check(clear); }, 500);
    })(0);
  }

  /* ---------- detección ---------- */

  function detect() {
    var url = '/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true';
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (j) {
        var country = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        var lang = null;
        var s = j && j.suggestions && j.suggestions[0] && j.suggestions[0].parts;
        if (s && s.language && s.language.handle) lang = s.language.handle;
        if (s && s.country && s.country.handle && !country) country = s.country.handle;
        return { country: country ? String(country).toUpperCase() : null, lang: lang ? String(lang).toLowerCase() : null };
      });
  }

  function pickLang(det) {
    if (det.lang && hasLang(det.lang)) return det.lang;
    if (det.lang && hasLang(det.lang.slice(0, 2))) return det.lang.slice(0, 2);
    if (det.country && SPANISH.indexOf(det.country) !== -1 && hasLang('es')) return 'es';
    var nav = String(navigator.language || '').slice(0, 2).toLowerCase();
    if (det.country && hasLang(nav)) return nav;
    if (det.country && hasLang('en')) return 'en';
    return data.locale;
  }

  function init() {
    root = document.querySelector('[data-basiq-geo]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    try { data = JSON.parse(root.querySelector('[data-gp-data]').textContent); } catch (e) { return; }
    /* Fuera de la sección para que ningún contenedor de la página lo tape */
    if (root.parentNode !== document.body) document.body.appendChild(root);

    var preview = !!root.getAttribute('data-preview');
    if (window.Shopify && window.Shopify.designMode && !preview) return;
    if (!preview && done()) return;
    if (/bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) return;

    bind();

    detect().then(function (det) {
      if (preview && !det.country) det = { country: 'GB', lang: 'en' };
      var countryOk = det.country && byIso(det.country);
      var targetCountry = countryOk ? det.country : data.country;
      var targetLang = pickLang(det);

      if (!preview && targetCountry === data.country && targetLang === data.locale) { remember(); return; }

      state.detected = countryOk ? det.country : null;
      sel.country = targetCountry;
      sel.locale = targetLang;
      window.setTimeout(function () { afterConsent(open); }, 400);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { root = null; init(); });
})();
